module.exports = __webpack_public_path__ + "img/GreenOutline300.e784f3a5.png";